import * as React from 'react';
import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';

import { media } from '../../theme/media';

import { Icon, IconNames, IconColors } from './Icon';
import { themeGet } from '../../theme/utils';
import { Badge } from '../misc';

const Container = styled.div<SpaceProps>`
  ${space};
  position: relative;
  text-align: center;
  display: block;
  font-weight: ${themeGet.fontWeight('lighter')};
  font-size: ${themeGet.fontSize(0)};
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  transition: 200ms linear;
  color: ${themeGet.colors('sandDune')};
  &:hover {
    color: ${themeGet.colors('primary')};
  }
`;

const Label = styled.span`
  display: inline-block;
`;

const BadgeCount = styled(Badge)`
  position: absolute;
  z-index: 1;
  bottom: calc(${themeGet.space(1)} / 2);
  right: 0;
`;

const IconContainer = styled.div`
  width: 32px;
  height: 24px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  ${media.to.sm`
    width: 24px;
  `};
`;

export interface IconWithLabelProps {
  icon: IconNames;
  color?: IconColors;
  hoverColor?: IconColors;
  badgeCount?: number;
  className?: string;
}

export const IconWithLabel: React.FC<IconWithLabelProps> = ({
  icon,
  color = 'inherit',
  badgeCount = 0,
  className,
  children,
}) => (
  <Container className={className} mx={[1, 1, 2, 2, 3]}>
    <IconContainer>
      {badgeCount > 0 && <BadgeCount>{badgeCount}</BadgeCount>}
      <Icon color={badgeCount > 0 ? 'primary' : color} name={icon} />
    </IconContainer>
    <Label>{children}</Label>
  </Container>
);
